import React from 'react';
import { Icon } from './Icon';
import './ErrorMessage.css';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onRetry
}) => {
  return (
    <div className="error-message">
      <div className="error-message__container">
        <div className="error-message__icon"><Icon name="FaExclamationTriangle" size={48} /></div>
        <div className="error-message__content">
          <h3 className="error-message__title">
            Something went wrong
          </h3>
          <p className="error-message__text">
            {message}
          </p>
          {onRetry && (
            <button 
              className="error-message__retry"
              onClick={onRetry}
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  );
};







